import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['listItem', 'showMore']

  declare readonly listItemTargets: HTMLElement[]
  declare readonly showMoreTarget: HTMLElement

  showMore (event: any): void {
    event.preventDefault()

    this.listItemTargets.forEach(item => {
      if (item.classList.contains('hidden')) {
        item.classList.remove('hidden')
      }
      item.classList.add('show')
    })

    this.showMoreTarget.classList.remove('show')
  }
}
